import { IEntityValidation } from './BorrowerApi';
import { BfiApi, IApiResponse } from './bfiApi';
import { IAddress } from 'libs/store/src/cross';

export interface IEntity {
    id: number;
    companyId?: number;
    name: string;
    tin: string;
    entityType: number;
    stateIncorporated: string;
    yearIncorporated?: Date;
}

export interface ICompany extends IAddress {
    companyId: number;
    name: string;
    physicalAddressSameAsMailing: boolean;
    physicalAddressStreet1: string;
    physicalAddressStreet2: string;
    physicalAddressCity: string;
    physicalAddressState: string;
    physicalAddressZipCode: string;
    physicalAddressCounty?: string;
}

export interface IReferencePanel {
    id?: number;
    type?: string;
    companyName?: string;
    contactName?: string;
    phoneNumber?: string;
    email?: string;
}

export class BusinessAndPeopleApi extends BfiApi {
    getBorrowerBusinessById(id: number): Promise<IApiResponse> {
        return super.get(`/businessandpeople/apply/companies/${id}`);
    }

    getBorrowerBusinesses(): Promise<IApiResponse> {
        return super.get(`/businessandpeople/apply/borrower/businesses`);
    }

    getDoesBorrowerEntityWithoutUmbrellaCompanyExist(): Promise<IApiResponse> {
        return super.get(`/businessandpeople/apply/borrower/nobusiness`);
    }

    saveBorrowerBusiness(model: ICompany): Promise<IApiResponse> {
        return super.post(`/businessandpeople/apply/companies`, model);
    }

    getBorrowerEntities(companyId: number): Promise<IApiResponse> {
        return super.get(`/businessandpeople/apply/borrower/entities/user/grid/${companyId}`);
    }

    getBorrowerEntityById(id: number): Promise<IApiResponse> {
        return super.get(`/businessandpeople/apply/borrower/entities/${id}`);
    }

    validateBorrowerEntity(model: IEntityValidation): Promise<IApiResponse> {
        return super.post(`/businessandpeople/apply/entities/validate`, model);
    }

    saveBorrowerEntity(model: IEntity): Promise<IApiResponse> {
        return super.post('/businessandpeople/apply/entities', model);
    }

    getBorrowerEntityOwners(id: number): Promise<IApiResponse> {
        return super.get(`/businessandpeople/apply/borrower/entities/${id}/owners/grid`);
    }
}
